import { Injectable } from '@angular/core';
import { IconSettingsService } from '@progress/kendo-angular-icons';

@Injectable()
export class KendoIconsService extends IconSettingsService {
    private iconDictionary: Record<string, string> = {
        'caret-alt-down': 'icon icon-arrow-down-s',
        'caret-alt-up': 'icon icon-arrow-up-s',
        x: 'icon icon-close',
        undo: 'icon icon-22 icon-undo',
        redo: 'icon icon-22 icon-redo',
        image: 'icon icon-18 icon-insert-image',
        mention: 'icon icon-18 icon-mention-s',
        horizontal: 'icon icon-20 icon-minus',
        plus: 'icon icon-arrow-down-s',
        minus: 'icon icon-arrow-up-s',
        'clear-css': 'icon icon-24 icon-eraser'
    };

    public override getCustomFontIconClass(iconName: string): string {
        return this.iconDictionary[iconName] || super.getCustomFontIconClass(iconName);
    }
}
